import React, { useCallback, useRef, useState, useEffect } from 'react'
import Profile from '../Profile/Profile';
import { Link } from 'react-router-dom';
import { useDropzone } from 'react-dropzone'
import csv from 'csv';
import firebase, { db } from '../../../constants/firebase';
import { useMutation, useQueryClient } from 'react-query';
import { addLocation } from '../../../data/Locations';
import { getGeoCode } from '../../../data/Locations/getGeoCode';
import { setGeoPoint } from '../../../data/Locations/setGeoPoint';

const LargeScreenMenu = (props) => {
    const queryClient = useQueryClient()
    const [docRef, setDocRef] = useState(null)
    const [coords, setCoords] = useState('Please generate coordinates for this location')
    const createLocation = useMutation(locationInfo => addLocation(locationInfo))
    const [isImporting, setIsImporting] = useState(false)

    const getCoordinates = (async (location) => {
        const addressString = `${location.street} ${location.city} ${location.state} ${location.zip}`
        const geoCode = await getGeoCode(addressString)
        const newLocation = new firebase.firestore.GeoPoint(geoCode.results[0].geometry.location.lat, geoCode.results[0].geometry.location.lng)
        setCoords(`${geoCode.results[0].geometry.location.lat}, ${geoCode.results[0].geometry.location.lat}`)
        setGeoPoint(location.docRef, newLocation)
    })


    const onDrop = useCallback(acceptedFiles => {
        setIsImporting(true)
        console.log(acceptedFiles[0].name)
        console.log("Now you can do anything with this file as per your requirement")
        console.log(acceptedFiles[0])

        var file = acceptedFiles[0];

        const reader = new FileReader();
        reader.onload = () => {
        csv.parse(reader.result, (err, data) => {

            for (var i = 1; i < data.length; i++) {
                // Read one new location from the file
                const locationName = data[i][0];
                const streetAddress = data[i][1];
                const city = data[i][2];
                const state = data[i][3];
                const zip = data[i][4];
                const hours = data[i][5];
                const phone = data[i][6];
                const type = data[i][7]; // shelter, emergency, safeplace
                const newLocation = { "name": locationName, "city": city, "hours": hours, "lat": "", "lon": "", "phone": phone, "state": state, "street": streetAddress, "type": type, "zip": zip };

                // Create a unique docRef and save the data to firestore
                const docRef = db.collection('locations').doc().id
                console.log("docRef is set to ",docRef)
                const locationInfo = { ...newLocation, docRef }

                // Get the coordinates
                getCoordinates(locationInfo)

                console.log("locationInfo: ",locationInfo)
                createLocation.mutate(locationInfo)
                queryClient.invalidateQueries('locations')
                
            };
        });
        };

        reader.readAsBinaryString(file);
        setIsImporting(false)
        alert("Items successfully imported")
    }, [])
      
    const { getInputProps, getRootProps } = useDropzone({ onDrop })
      

    return (
        <div className="hidden md:flex md:flex-shrink-0">
            <div className="flex flex-col w-64">
                <div className="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white">
                    <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
                        <div className="flex items-center flex-shrink-0 px-4">
                            <img className="h-auto w-auto" src="/assets/logo.jpg" alt="Organization Logo" />
                        </div>
                        <nav className="mt-5 flex-1 px-2 bg-white space-y-1">
                            <button type="button" className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dkpurple hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <Link to='./'>Home</Link>
                            </button>
                            <button type="button" className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dkpurple hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <Link to='add'>Add Location</Link>
                            </button>
                        </nav>
                    </div>
                    
                    <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <p className="p-4 m-10 text-center border-dotted border-2 border-black rounded-md">{isImporting ? "Importing..." : "Click here to select a file or drag-and-drop a .CSV file here to bulk add locations."}</p>
                    </div>

                    <Profile currentUser={props.currentUser} />
                </div>
            </div>
        </div>
    )
}

export default LargeScreenMenu